import { Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from "@mui/material";
import { SwAlert } from "components";
import { BtnDeleteTable, BtnEditTable, BtnPDFTable, BtnCancelIcon } from "components/Button";
import { ColumnProps } from "components/TableUI/TableUI";
import React from "react";
import { AiFillEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { Encrypt } from "utilities/Function";
import { DeleteUserRecruitment, onCheckEditItem } from "./CallAPI";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
import { FnBlock_UI } from "components/BlockUI";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0053b5",
        color: theme.palette.common.white,
        border: '1px solid rgba(224, 224, 224, 1) !important',
        padding: '10px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: '8px',
        border: '1px solid rgba(224, 224, 224, 1) !important',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Pupput = (prop) => {
    const [open, setOpen] = React.useState(false);
    const [lstDataEditItem, setlstDataEditItem] = React.useState([]);
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const navigate = useNavigate();
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        prop.handleClose(false);
    };

    React.useEffect(() => {
        if (prop.open) handleClickOpen();
    }, [prop.open])

    React.useEffect(() => {
        setlstDataEditItem(prop.lstDataEditItem || [])
    }, [prop.lstDataEditItem])
    //#region Column
    const ColumnData: ColumnProps[] = [
        {
            id: "nNo",
            name: "ลำดับ",
            width: "5%",
            cellAlign: "center"
        },
        {
            id: "sRegisterCode",
            name: "เลขที่ใบสมัคร",
            width: "5%",
            cellAlign: "left"
        },
        {
            id: "sName",
            name: "ชื่อ - นามสกุล",
            width: "40%",
            cellAlign: "left"
        },
        {
            id: "sPositionName",
            name: "ตำแหน่งที่สนใจ",
            width: "20%",
            cellAlign: "left"
        },
        {
            id: "sStatusName",
            name: "สถานะ",
            width: "15%",
            cellAlign: "center",
        },
        {
            id: "sRegisterDate",
            name: "วันที่สมัคร",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "sUpdateDate",
            name: "วันที่แก้ไข",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "sUpdateByName",
            name: "ผู้แก้ไข",
            width: "15%",
            cellAlign: "left"
        },
        {
            id: "Button",
            name: "",
            width: "8%",
            cellAlign: "center",
        }
    ];
    //#endregion
    const onEdit = (sID, sMode) => {
        navigate("/UserRecruitment_From?str=" + Encrypt(sID))
    }

    const onDelete = (nID) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            DeleteUserRecruitment({ nID: nID }, () => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.DeleteComplete, () => {
                    onCheckEditItem({ sCodeUser: prop.sIDCard }, (res) => {
                        setlstDataEditItem(res.lstData || [])
                    }, BlockUI, UnBlockUI);
                });
            }, BlockUI, UnBlockUI);
        });
    }

    return (
        <Dialog
            maxWidth={"lg"}
            fullWidth={true}
            open={open}
            onClose={handleClose}
            sx={{ borderRadius: "23px" }}
        >
            <DialogTitle style={{
                borderBottom: "1px solid #FD8D14"
            }}><AiFillEdit /> ผู้สมัครมีรายการมากกว่า 1 รายการ</DialogTitle>
            <DialogContent>
                <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
                    <Grid item md={12} xs={12}>
                        <Paper sx={{ width: '100%' }}>
                            <TableContainer sx={{ maxHeight: 600 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <StyledTableRow>
                                            {ColumnData.map((column) => (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={"center"}
                                                    style={{ minWidth: column.width }}
                                                >
                                                    {column?.name}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {lstDataEditItem.map((row) => {
                                            let sStatusbackgroundColor = "";
                                            let sStatuColors = "";
                                            switch (row.nStatusID) {
                                                case 85: {
                                                    sStatusbackgroundColor = "rgb(255 248 233)";
                                                    sStatuColors = "rgb(165, 94, 0)";
                                                }
                                                    break;
                                                case 109: {
                                                    sStatusbackgroundColor = "rgb(19 191 0)";
                                                    sStatuColors = "rgb(185 255 157)"
                                                }
                                                    break;
                                            }
                                            return (
                                                <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.nID}>
                                                    {ColumnData.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <>
                                                                {column.id === "Button" ?
                                                                    <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                        <div style={{ display: "inline-flex", textAlign: "center" }}>
                                                                            <BtnEditTable title="แก้ไขข้อมูล" style={{ marginLeft: "5px" }} onClick={() => { onEdit(row.nID, "Edite") }} />
                                                                            {row.isDelete&&<BtnDeleteTable title="ลบข้อมูล" style={{ marginLeft: "5px" }} onClick={() => { onDelete(row.nID); }} />}
                                                                        </div>
                                                                    </StyledTableCell>
                                                                    :
                                                                    (column.id === "sStatusName" ?
                                                                        <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                            <Chip
                                                                                size="small"
                                                                                label={row.sStatusName}
                                                                                style={{
                                                                                    color: sStatuColors,
                                                                                    backgroundColor: sStatusbackgroundColor,
                                                                                    margin: "0.2rem",
                                                                                }}
                                                                            />
                                                                        </StyledTableCell>
                                                                        :
                                                                        <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                            {value}
                                                                        </StyledTableCell>
                                                                    )
                                                                }
                                                            </>
                                                        );
                                                    })}
                                                </StyledTableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <BtnCancelIcon onClick={handleClose} />
            </DialogActions>
        </Dialog>
    );
};
export default Pupput;